/** Where a scene sits, so a move can be put back. */
export function scenePlace(headers, sceneId) {
  const sequences = headers?.sequences || [];
  for (const sequence of sequences) {
    const ids = sequence.scene_ids || [];
    const index = ids.findIndex((id) => String(id) === String(sceneId));
    if (index >= 0) {
      return {
        sequenceId: sequence.id,
        afterSceneId: index > 0 ? ids[index - 1] : null,
        atStart: index === 0,
      };
    }
  }
  return null;
}

/** Where the scene sits on the card row, before a drag. */
export function visualPlace(row, sceneId) {
  const ids = (row?.scenes || []).map((scene) => String(scene.scene_id));
  const index = ids.findIndex((id) => id === String(sceneId));
  if (index < 0) return null;
  const sequenceId = row.sequence?.id || undefined;
  if (index === 0) return { sequenceId, afterSceneId: null, atStart: true };
  return { sequenceId, afterSceneId: ids[index - 1], atStart: false };
}

/** The place to send so a move returns to `from`. */
export function undoMove(from, sceneId) {
  if (!from || !sceneId) return null;
  if (from.atStart) {
    return { sceneId, sequenceId: from.sequenceId, atStart: true };
  }
  return {
    sceneId,
    sequenceId: from.sequenceId,
    afterSceneId: from.afterSceneId,
    atStart: false,
  };
}

/** The main-row text Add a scene can write back. Empty when there is none. */
export function sceneWhatHappens(board, sceneId) {
  const column = (board?.columns || []).find((col) => String(col.scene_id) === String(sceneId));
  if (!column) return '';
  const main = (board.rows || []).find((row) => row.type === 'main') || null;
  const cell = (board.cells || []).find((item) => (
    String(item.column_id) === String(column.id)
    && (!main || String(item.row_id) === String(main.id))
  ));
  const beat = Array.isArray(cell?.beats) ? cell.beats[0] : '';
  if (typeof beat === 'string' && beat.trim()) return beat.trim();
  return String(cell?.note || '').trim();
}
